<p *ngIf="fieldDescription" class="mb-0 mt-2">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>
<mat-form-field
  *ngIf="!readonlyInternal"
  class="w-100"
  [attr.data-automation-id]="dataAutomationId"
  [floatLabel]="floatLabel"
  [ngClass]="{ 'allow-pointer': tooltipText, 'no-label': hideLabel }"
>
  <mat-label>
    {{ labelOverride || fgInfo?.label
    }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <mat-select
    [placeholder]="placeholder"
    [required]="fgInfo.required"
    [formControl]="formControl"
    [multiple]="multiple"
    (selectionChange)="onChange()"
    [aria-label]="hideLabel ? fieldDescription : labelOverride || fgInfo.label"
  >
    <mat-option *ngIf="!multiple && showNullPlaceholder">-Select-</mat-option>
    <ng-container *ngIf="hasOneGroup">
      <mat-option
        *ngFor="let option of filteredGroups[0].options"
        [attr.data-automation-id]="dataAutomationId"
        [value]="option.value"
      >
        {{ option.name || '' }}
      </mat-option>
    </ng-container>
    <ng-container *ngIf="!hasOneGroup">
      <mat-optgroup *ngFor="let group of filteredGroups" [label]="group.name">
        <mat-option
          *ngFor="let option of group.options"
          [attr.data-automation-id]="dataAutomationId"
          [value]="option.value"
        >
          {{ option.name || '' }}
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-select>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonlyInternal">
  <mat-form-field
    class="no-underline w-100"
    [attr.data-automation-id]="dataAutomationId"
    floatLabel="always"
    [ngClass]="{
      'read-only': readonlyInternal,
      'allow-pointer': tooltipText,
      'no-label': hideLabel
    }"
  >
    <mat-label>
      {{ labelOverride || fgInfo.label }}
      <mat-icon
        [hidden]="!tooltipText"
        [matTooltip]="tooltipText"
        [matTooltipPosition]="'after'"
        [attr.aria-label]="'Tooltip: ' + tooltipText"
      >
        help
      </mat-icon>
    </mat-label>
    <textarea
      readonly
      matInput
      cdkTextareaAutosize
      [attr.data-automation-id]="dataAutomationId"
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      [value]="showTrimmedText ? trimmedText : overrideReadonlyValue || currentSelection || ''"
      tabindex="-1"
    ></textarea>
    <p *ngIf="showTrimmedText && noteIsLong">
      <span class="show-more" (click)="showTrimmedText = false">See more</span>
    </p>
    <p *ngIf="!showTrimmedText && noteIsLong">
      <span class="show-more" (click)="showTrimmedText = true">See less</span>
    </p>
  </mat-form-field>
</ng-container>
